
<template>
  <div class="max-w-xl mx-auto mt-8">
    <form class="space-y-6" @submit.prevent="addMaintenance">
      <div class="grid grid-cols-1 gap-6">
        <form-input
          v-model="localTime"
          type="datetime-local"
          label="Maintenance Start (Local)"
          :error-msg="localError"
          @input="syncUtcFromLocal"
        />
        <form-input
          v-model="utcTime"
          type="datetime-local"
          label="Maintenance Start (UTC)"
          :error-msg="utcError"
          @input="syncLocalFromUtc"
        />
      </div>
      <div class="flex justify-between gap-4">
        <button class="btn-outline" type="button" @click="$emit('cancel')">
          Cancel
        </button>

        <button class="btn-primary w-full h-10" :disabled="isSaving || !isValid" type="submit">
          Add Maintenance
        </button>
      </div>
    </form>
  </div>
</template>


<script setup>
import { ref, computed } from 'vue';
import FormInput from '../components/FormInput.vue';

const emit = defineEmits([ 'submit', 'cancel' ]);

const localTime = ref('');
const utcTime = ref('');
const isSaving = ref(false);
const localError = ref('');
const utcError = ref('');

function syncUtcFromLocal() {
  if (!localTime.value) {
    return;
  }
  const localDate = new Date(localTime.value);
  if (isNaN(localDate.getTime())) {
    localError.value = 'Invalid local time';
    return;
  }
  localError.value = '';
  utcTime.value = localDate.toISOString().slice(0, 16);
}

function syncLocalFromUtc() {
  if (!utcTime.value) {
    return;
  }
  const utcDate = new Date(utcTime.value + ':00Z');
  if (isNaN(utcDate.getTime())) {
    utcError.value = 'Invalid UTC time';
    return;
  }
  utcError.value = '';
  // Convert UTC to local string
  const localIso = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
  localTime.value = localIso;
}

const isValid = computed(() => {
  return localTime.value && utcTime.value && !localError.value && !utcError.value;
});

async function addMaintenance() {
  if (!isValid.value) {
    return;
  }

  emit('submit', { startAt: utcTime.value + ':00Z' });
}
</script>
